/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Cart = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 50 44" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M49.918 9.263l-5.995 21.999a1.001 1.001 0 0 1-.888.735l-23.334 1.796L18.598 36h22.363a1 1 0 0 1 0 2H16.982c-.345 0-.667-.18-.85-.474a1.003 1.003 0 0 1-.044-.972l1.29-2.581-.32.024c-.025.002-.05.002-.076.002a.997.997 0 0 1-.97-.757L8.416 2.726a.998.998 0 0 0-.962-.727H.997a1 1 0 1 1 0-2h6.457a3.01 3.01 0 0 1 2.898 2.226l1.442 5.794A1.01 1.01 0 0 1 11.987 8h36.967a.999.999 0 0 1 .964 1.263zM47.646 10h-35.36l5.462 21.938 24.432-1.882zM21.978 42a2 2 0 0 1-1.998 2.001 2 2 0 0 1 0-4c1.104 0 1.998.894 1.998 2zm17.984 0a2 2 0 0 1-1.998 2.001 2 2 0 0 1 0-4c1.103 0 1.998.894 1.998 2z" /><path d="M21.978 18.375c0-2.417 1.987-4.374 4.44-4.374a4.44 4.44 0 0 1 3.553 1.773 4.438 4.438 0 0 1 3.552-1.773c2.452 0 4.44 1.957 4.44 4.374 0 3.084-7.111 9.625-7.98 9.625h-.025c-.869 0-7.98-6.541-7.98-9.625zm1.998 0c0 1.451 4.033 5.815 5.994 7.33 1.963-1.515 5.995-5.88 5.995-7.33 0-1.31-1.095-2.375-2.442-2.375-.774 0-1.488.358-1.959.98l-1.593 2.11-1.595-2.11a2.435 2.435 0 0 0-1.957-.98c-1.347 0-2.443 1.066-2.443 2.375z" />
      </g>
    </svg>
  </span>
);

Cart.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Cart.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Cart;
